var $ = require('jQuery');

module.exports = function() {
	var roundTypeButtons = $('input:radio[name=roundType]');

	var roundTypeOptions = function() {
	    switch(roundTypeValue()) {
            case 'judge':
                $('#entryViewContainer').hide();
                $('#feedbackViewContainer').hide();

                $('#judgingViewContainer').show();
                $('.judging-hidden').hide();
                break;
            case 'feedback':
                $('#judgingViewContainer').hide();
                $('#entryViewContainer').hide();
                $('.judging-hidden').show();

                $('#feedbackViewContainer').show();
                break;
            case 'entry':
            default:
                $('.judging-hidden').show();
                $('#judgingViewContainer').hide();
                $('#feedbackViewContainer').hide();

                $('#entryViewContainer').show();
                break;
        }
    }

	/**
	 * Returns the value fo the selected round type, if its selected.
	 *
	 * @returns string
	 */
	var roundTypeValue = function() {
		var roundType = $('input:radio[name=roundType]:checked');

		if (roundType) {
			return roundType.val();
		}
	}

	var checkAll = function() {
		var column = $(this).data('column');
		var check = false;

		if ($(this).prop('checked')) {
			check = true;
		}

		$('.multiselect-subset-control.' + column).each(function() {
			var enabled = $(this).siblings('label').first().find('input:checked');

			if (check && enabled.length) {
				$(this).find('input').prop('checked', true);
			}
			else {
				// We always uncheck, even if the category isn't enabled
				$(this).find('input').prop('checked', false);
			}
		});
	};

	roundTypeOptions();

	roundTypeButtons.click(roundTypeOptions);

	$('input[data-column]').change(checkAll);
};
